/**
 * @Description:我们
 * @author: Xiao'Hong
 * @date: 2021/2/22
 * @fileName: we
 */
export default [
    {path: "/we", component: () => import('@/views/we/we.vue')},
]
